import React from "react";
import "./AboutUs.css"; // Include the CSS file

const AboutUs = () => {
  return (
    <div className="about-container">
      <div className="about-content">
        <h1>About StockVia</h1>
        <p className="tagline">
          Your Gateway to Smarter Stock Market Decisions
        </p>

        <p>
          Welcome to <strong>StockVia.in</strong> — a modern platform built to
          empower Indian investors and learners with reliable, timely, and
          easy-to-understand stock market information.
        </p>

        <h2>What We Do</h2>
        <ul>
          <li>
            <strong>Stock Recommendations:</strong> We curate suggestions from
            trusted and verified advisory firms.
          </li>
          <li>
            <strong>Dividend Alerts:</strong> Stay updated on companies about to
            issue dividends.
          </li>
          <li>
            <strong>Bonus & Split Updates:</strong> Track stock bonus issues and
            split announcements.
          </li>
          <li>
            <strong>IPO Coverage:</strong> Get fresh details on new and upcoming
            Initial Public Offerings.
          </li>
          <li>
            <strong>Quarterly Results Calendar:</strong> Keep an eye on key
            earnings reports.
          </li>
          <li>
            <strong>Finance News:</strong> Follow hand-picked finance headlines
            and market-moving news.
          </li>
          <li>
            <strong>Learn the Market:</strong> Browse simplified learning
            resources to build your stock market knowledge.
          </li>
        </ul>

        <h2>Our Mission</h2>
        <p>
          To simplify access to quality stock market information, help new and
          experienced investors stay informed, and foster financial literacy
          among the Indian audience.
        </p>

        <h2>Why Trust Us?</h2>
        <p>
          We believe in transparency, credible sources, and providing only
          what’s relevant. Our content is curated from reliable firms,
          regulatory announcements, and verified financial data platforms.
        </p>

        <h2>Stay Connected</h2>
        <p>
          Join us on our journey via{" "}
          <a
            href="https://instagram.com/stockvia"
            target="_blank"
            rel="noopener noreferrer"
          >
            Instagram
          </a>{" "}
          or check back regularly for updates. StockVia is more than a site —
          it's a growing community of learners and investors.
        </p>

        <p className="closing-line">Thank you for choosing StockVia!</p>
      </div>
    </div>
  );
};

export default AboutUs;
